import * as React from 'react';
import * as Images from 'pos/Images';

import { Preconditions } from 'core/infrastructure-next';
import { ProductForMenuConfigurationDTO, ProductGroupForSaleDTO, Res, Permission, ProductGroupType, MenuGroupConfigurationDTO } from 'core/api';
import { ValueButtonGrid, PosScreenClassComponent, ScreenSize, ActionButtonDefinition } from 'pos/ui';
import { addPrecondition } from 'pos/common';
import { CatalogueFacade } from 'pos/facades';
import { Flex } from 'core/ui';
import { Modal } from 'core/ui-next/modal';

type Props = { groups: ProductGroupForSaleDTO[], menuGroup: MenuGroupConfigurationDTO } & Modal.Actions<void>;
type Status = { selectedGroup: Nullable<ProductGroupForSaleDTO>, products: ProductForMenuConfigurationDTO[] };

class SelectProductScreen extends PosScreenClassComponent<Props, Status> {

	createInitialState(_props: Props): Nullable<Status> {
		return { selectedGroup: null, products: [] };
	}

	protected getScreenId(): string {
		return 'SELECT_PRODUCT_FOR_MENU_CONFIGURATION';
	}

	protected getTitle(): string {
		return Res.Web.ADD_PRODUCT_TO_MENU_GROUP();
	}

	protected getImage(): string | SvgIcon {
		return Images.ComposeMenu;
	}

	protected useKeypad(): boolean {
		return false;
	}

	protected getSize(): ScreenSize {
		return 'medium';
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return [
			this.cancelButton(),
			null,
			null,
			null,
			null,
			null
		];
	}

	onSelectGroup = async (value: ProductGroupForSaleDTO) => {
		if (value.Type !== ProductGroupType.Category && value.Type !== ProductGroupType.Family)
			throw new Error('Aquí sólo debería haber familias y categorías');

		const products = value.Type === ProductGroupType.Family ?
			await CatalogueFacade.getProductsByFamilyForMenu(value.Id) :
			await CatalogueFacade.getProductsByCategoryForMenu(value.Id);

		this.setState({ selectedGroup: value, products });
	};

	onProductSelected = async (selectedProduct: ProductForMenuConfigurationDTO) => {
		await CatalogueFacade.addProductToMenuGroup(this.props.menuGroup, selectedProduct);
		this.close();
	};

	protected getContent(): React.ReactNode {
		return <>
			<Flex.Vertical>
				<Flex.Item>
					<ValueButtonGrid className='border-bottom' rows={2} values={this.props.groups} onValueSelected={this.onSelectGroup} />
				</Flex.Item>
				<Flex.Item size='*'>
					<ValueButtonGrid rows={'fill'} values={this.state.products} onValueSelected={this.onProductSelected} />
				</Flex.Item>
			</Flex.Vertical>
		</>;
	}

	onComponentDidMount(): void {
	}

	onComponentWillUnmount(): void {
	}
}

async function selectProduct(menuGroup: MenuGroupConfigurationDTO): Promise<Result<void>> {
	const groups = await CatalogueFacade.getAllProductGroupsForMenu();
	return await Modal.show(SelectProductScreen, { groups: groups, menuGroup: menuGroup });
}

export default addPrecondition(Preconditions.ensure(Permission.Menu_Configure), selectProduct);